// ======================================================================
// File Name       : modal
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const MODAL_OPEN_MODAL = 'MODAL_OPEN_MODAL';
export const MODAL_HIDE_MODAL = 'MODAL_HIDE_MODAL';
export const SHOW_HINT_MODAL = 'SHOW_HINT_MODAL';
export const CLOSE_HINT_MODAL = 'CLOSE_HINT_MODAL';
